export const UPDATE_OPS_DASHBOARD_LAST_UPDATED =
  "UPDATE_OPS_DASHBOARD_LAST_UPDATED";

export const SELECTED_LANDING_DASHBOARD = "SELECTED_LANDING_DASHBOARD";

export const UPDATE_AZURE_DASHBOARD_LAST_UPDATED =
  "UPDATE_AZURE_DASHBOARD_LAST_UPDATED";
